
import { Component, Vue } from 'vue-property-decorator'
import { comparePlaces, CompareResult } from '@/api/placesCompare'
import ProviderColumn from './ProviderColumn.vue'

@Component({ name: 'PlacesCompare', components: { ProviderColumn } })
export default class extends Vue {
  private loading = false
  private result: CompareResult | null = null
  private preset = 'Kadıköy'

  // Real neighbourhoods rather than round coordinates: an empty square tells
  // you nothing about either provider.
  private presets = [
    { name: 'Kadıköy', latitude: '40.9902', longitude: '29.0270' },
    { name: 'Sultanahmet', latitude: '41.0055', longitude: '28.9769' },
    { name: 'Ankara Kızılay', latitude: '39.9208', longitude: '32.8541' },
    { name: 'Berlin Mitte', latitude: '52.5200', longitude: '13.4050' },
    { name: 'London Camden', latitude: '51.5390', longitude: '-0.1426' }
  ]

  private categories = ['all', 'food', 'shop', 'pubs', 'art', 'college', 'fitness', 'professional']

  private form = {
    latitude: '40.9902',
    longitude: '29.0270',
    categoryId: 'food',
    query: '',
    radius: 500,
    fresh: false
  }

  private get googleNameSet(): string[] {
    return this.result ? this.result.google.pois.map(p => this.norm(p.name)) : []
  }

  private get geoNameSet(): string[] {
    return this.result ? this.result.geoapify.pois.map(p => this.norm(p.name)) : []
  }

  private norm(s: string) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9çğıöşü]/gi, '')
  }

  private applyPreset(name: string) {
    const p = this.presets.find(x => x.name === name)
    if (p) {
      this.form.latitude = p.latitude
      this.form.longitude = p.longitude
    }
  }

  private async run() {
    this.loading = true
    try {
      const res: any = await comparePlaces({
        latitude: this.form.latitude,
        longitude: this.form.longitude,
        categoryId: this.form.categoryId,
        query: this.form.query || undefined,
        radius: this.form.radius,
        fresh: this.form.fresh
      })
      this.result = res.data.data
    } catch (err: any) {
      this.$message.error(
        err?.response?.data?.status?.message || err?.message || (this.$t('placesCompare.failed') as string)
      )
    } finally {
      this.loading = false
    }
  }

  private created() {
    this.run()
  }
}
